// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4705) return "static/chunks/dc112a36-13217b3351317b65.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8445 ? "bc98253f" : chunkId) + "." + {"1411":"9a3ba646e0060601","5243":"ba5f5e4c311b2f1b","7882":"3fc7fb0e15ef3c43","8445":"fc4292ebfa2ae67e"}[chunkId] + ".js";
};